import * as React from "react";
import { render } from "react-dom";
import { firebaseConfig } from "./credentials";
import { FirebaseAppProvider } from "reactfire";
import {
  isTemplateExpression,
  ModuleResolutionKind,
  WhileStatement,
} from "typescript";
import { ListSelect } from "./components/ListSelect";
import { wordId } from "./idGenerate";
console.log(wordId(3));

export const colors = [
  "#c2c9d1",
  "#62b7f4",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#6b7c8e",
];
export const itemColors = [
  "#c2c9d1",
  "#62b7f4",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#a685e2",
];

export const itemColorsLight = [
  "#d9dee2",
  "#8dcbf7",
  "#5AD8C1",
  "#FFD270",
  "#ffa375",
  "#bfa8eb",
];

const App = () => {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <React.Suspense fallback="loading">
        <ListSelect />
      </React.Suspense>
    </FirebaseAppProvider>
  );
};

export default App;
